<script setup>
import { ref, watchEffect, onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import MainScene from '~/components/tresJs/MainScene.vue';


const store = usePageStore();
const pageContent = computed(() => store.pageContent);
const isMobile = ref(true);

const lenisRef = ref(null)
const lenisOptions = {
  // lenis options (optional)
}

watchEffect((onInvalidate) => {
   if (!lenisRef.value?.lenis) return

  //  if using GSAP ScrollTrigger, update ScrollTrigger on scroll
  // attach ScrollTrigger update to Lenis scroll
  const lenis = lenisRef.value.lenis
  if (lenis?.on) {
    lenis.on('scroll', ScrollTrigger.update)
  }

  // add the Lenis requestAnimationFrame (raf) method to GSAP's ticker
  // this ensures Lenis's smooth scroll animation updates on each GSAP tick
  function update(time) {
    lenisRef.value.lenis.raf(time * 1000)
  }
  gsap.ticker.add(update)

  // disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0)

  // clean up GSAP's ticker from the previous execution of watchEffect, or when the effect is stopped
  onInvalidate(() => {
    gsap.ticker.remove(update)
    if (lenis?.off) {
      lenis.off('scroll', ScrollTrigger.update)
    }
  })
})

onMounted(() => {
  if ( window.innerWidth >= 1024){
    isMobile.value = false;
  }
  gsap.registerPlugin(ScrollTrigger, SplitText);
})

</script>

<template>
  <ClientOnly>
    <VueLenis ref="lenisRef" root v-if="!isMobile"/>
  </ClientOnly>
  <NuxtLayout>
    <NuxtPage :key="$route.fullPath" />
  </NuxtLayout>
   <ClientOnly>
     <MainScene :page-content="pageContent" />
   </ClientOnly>
</template>
